import React from "react";
import PropTypes from "prop-types";

let ReactQuill = null;
import "react-quill/dist/quill.snow.css";
let Quill = null;
let Font = null;
try {
  ReactQuill = require("react-quill").default;
  Quill = ReactQuill.Quill;
  Font = Quill.import("formats/font");
  console.log("ReactQuill Fonts:", Font);
  Font.whitelist = [
    "Vodafone",
    "Lato",
    "Montserrat",
    "Open Sans",
    "Raleway",
    "Roboto",
    "Rubik",
    "Sans Serif",
    "Ubuntu",
    "Verdana",
  ];
  Quill.register(Font, true);
} catch (error) {
  console.error(error.message);
}
// if ((typeof window != 'undefined' && window.document)) {
// import ReactQuill from 'react-quill';

export default class RichTextEditor extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    colors: PropTypes.array,
    toolbar: PropTypes.array,
    disabled: PropTypes.bool,
  };
  constructor(props) {
    super(props);
    this.state = { value: props.value };
    this.quillRef = null;
    this.defaultFontApplied = false;
  }
  UNSAFE_componentWillReceiveProps(props) {
    this.setState({ value: props.value });
  }
  setDefaultFont = () => {
    if (this.quillRef && !this.defaultFontApplied) {
      const editor = this.quillRef.getEditor();
      editor.format('font', 'Vodafone');
      this.defaultFontApplied = true;
    }
  };
  componentDidMount() {
    this.setDefaultFont();
  }
  componentDidUpdate(prevProps) {
    this.setDefaultFont();
  }
  getValue = () => {
    return this.state.value;
  };
  onChange = (value) => {
    if (this.props.onChange) {
      this.props.onChange({ target: { value } });
    } else {
      this.setState({ value });
    }
  };
  handleQuillRef = (ref) => {
    this.quillRef = ref;
  };
  renderQuill = (restProps, parentId) => {
    if (!ReactQuill) {
      return <textarea>{this.state.value}</textarea>;
    }
    const colors = this.props.colors || [];
    const modules = {
      toolbar: [
        [{ header: [1, 2, 3, 4, false] }],
        ["bold", "italic", "underline", "strike", "blockquote"],
        [{ color: colors }, { background: colors }],
        [
          { list: "ordered" },
          { list: "bullet" },
          { indent: "-1" },
          { indent: "+1" },
        ],
        ["link", "image"],
        ["clean"],
      ],
      clipboard: {
        matchVisual: false,
      },
    };
    const fonts = Font ? Font.whitelist : [];
    modules.toolbar = [[{ font: fonts }]].concat(modules.toolbar);
    const formats = [
      "font",
      "header",
      "bold",
      "italic",
      "underline",
      "strike",
      "blockquote",
      "color",
      "background",
      "list",
      "bullet",
      "indent",
      "align",
      "link",
      "image",
      "video",
    ];
    return (
      <ReactQuill
        {...restProps}
        ref={this.handleQuillRef}
        modules={modules}
        formats={formats}
        value={this.state.value}
        onChange={this.onChange}
        // bounds={`#${parentId }`}
      />
    );
  };
  render() {
    const { className, showFonts, fonts, ...restProps } = this.props;
    const parentId = `rte-${Math.random()}`.split(".").join("-");
    return (
      <div id={parentId} className={`rich-text-editor pos-rel ${className}`}>
        {this.renderQuill(restProps, parentId)}
      </div>
    );
  }
}

export class SimpleTextEditor extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    colors: PropTypes.array,
    toolbar: PropTypes.array,
  };
  constructor(props) {
    super(props);
    this.state = { value: props.value };
  }
  UNSAFE_componentWillReceiveProps(props) {
    this.setState({ value: props.value });
  }
  getValue = () => {
    return this.state.value;
  };
  onChange = (value) => {
    if (this.props.onChange) {
      this.props.onChange({ target: { value } });
    } else {
      this.setState({ value });
    }
  };
  renderQuill = (restProps, parentId) => {
    if (!ReactQuill) {
      return <textarea>{this.state.value}</textarea>;
    }
    const colors = this.props.colors || [];
    const modules = {
      toolbar: [
        [{ header: [1, 2, 3, 4, false] }],
        ["bold", "italic", "underline", "blockquote"],
        [{ color: colors }, { background: colors }],
        [{ list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
        ["clean"],
      ],
      clipboard: {
        matchVisual: false,
      },
    };
    const fonts = Font ? Font.whitelist : [];
    modules.toolbar = [[{ font: fonts }]].concat(modules.toolbar);
    const formats = [
      "font",
      "header",
      "bold",
      "italic",
      "underline",
      "blockquote",
      "color",
      "background",
      "list",
      "bullet",
      "indent",
      "align",
    ];
    return (
      <ReactQuill
        {...restProps}
        modules={modules}
        formats={formats}
        value={this.state.value}
        onChange={this.onChange}
        // bounds={`#${parentId }`}
      />
    );
  };
  render() {
    const { className, showFonts, fonts, ...restProps } = this.props;
    const parentId = `rte-${Math.random()}`.split(".").join("-");
    return (
      <div id={parentId} className={`rich-text-editor pos-rel ${className}`}>
        {this.renderQuill(restProps, parentId)}
      </div>
    );
  }
}

export class ImageEditor extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
  };
  constructor(props) {
    super(props);
    this.state = { value: props.value };
  }
  UNSAFE_componentWillReceiveProps(props) {
    this.setState({ value: props.value });
  }
  getValue = () => {
    return this.state.value;
  };
  onChange = (value) => {
    if (this.props.onChange) {
      this.props.onChange({ target: { value } });
    } else {
      this.setState({ value });
    }
  };
  renderQuill = (restProps, parentId) => {
    if (!ReactQuill) {
      return <textarea>{this.state.value}</textarea>;
    }
    const modules = {
      toolbar: [["link", "image"]],
      clipboard: {
        matchVisual: false,
      },
    };
    const formats = ["link", "image", "video"];
    return (
      <ReactQuill
        {...restProps}
        modules={modules}
        formats={formats}
        value={this.state.value}
        onChange={this.onChange}
        // bounds={`#${parentId }`}
      />
    );
  };
  render() {
    const { className, ...restProps } = this.props;
    const parentId = `rte-${Math.random()}`.split(".").join("-");
    return (
      <div id={parentId} className={`rich-text-editor pos-rel ${className}`}>
        {this.renderQuill(restProps, parentId)}
      </div>
    );
  }
}
